export default "__VITE_ASSET__BFcbrkHB__"